import { Component } from '@verndale/core';

class Module extends Component {
  setupDefaults() {
    this.dom = {
        $tabButtons: this.el.querySelectorAll('.nav-tabs a'),
        $tabPannels: this.el.querySelectorAll('.tab-pane'),
        $mobileFormSelector: this.el.querySelector('.mobile-from-selector'),
    };

    console.log(this.dom.$mobileFormSelector);
  }

  

  addListeners() {
    this.dom.$tabButtons.forEach(btn => {
      btn.addEventListener('click', this.toggleTab.bind(this));
    });
    this.dom.$mobileFormSelector.addEventListener('change', this.toggleMobileTab.bind(this));
  }

  toggleTab(e) {
    e.preventDefault();
    this.dom.$tabButtons.forEach(btn => {
      if (btn === e.currentTarget) {
        btn.setAttribute('aria-selected', 'true');
      } else {
        btn.setAttribute('aria-selected', 'false');
      }
    });
    
    this.dom.$tabPannels.forEach(pannel => {
      if (
        pannel.getAttribute('id') ===
        e.currentTarget.getAttribute('aria-controls')
      ) {
        pannel.classList.add('active');
      } else {
        pannel.classList.remove('active');
      }
    });

    this.dom.$mobileFormSelector.value = e.currentTarget.getAttribute('aria-controls');

  }

  toggleMobileTab(e) {
    const val = e.currentTarget.value;

    this.dom.$tabPannels.forEach(pannel => {
        if (
          pannel.getAttribute('id') === val
        ) {
          pannel.classList.add('active');
        } else {
          pannel.classList.remove('active');
        }
    });

    this.dom.$tabButtons.forEach(btn => {
        if (btn.getAttribute('aria-controls') === val) {
          btn.setAttribute('aria-selected', 'true');
        } else {
          btn.setAttribute('aria-selected', 'false');
        }
      });
  }
}

export default Module;
